// Mapper: transport LC_GetTodayAttendanceSummaryOut → domain model for the
// "Mi equipo" dashboard "Situación de asistencia" card (ASIS-5404 / REXASIS-003).
// The backend only sends the raw counts; the percentage/isEmpty business rules are
// computed here so the UI never re-implements them.

import type {
  LC_GetTodayAttendanceSummaryOut,
  MyTeamAttendanceSummary,
} from '../types/myTeamAttendanceSummary.types';


export function mapMyTeamAttendanceSummary(
  out: LC_GetTodayAttendanceSummaryOut,
): MyTeamAttendanceSummary {
  const isEmpty = out.totalSupervisedCount === 0;
  const percentage = isEmpty
    ? 0
    : Math.round((out.presentCount / out.totalSupervisedCount) * 100);

  return {
    presentCount: out.presentCount,
    totalSupervisedCount: out.totalSupervisedCount,
    percentage,
    isEmpty,
  };
}
